import { operatorApiFetch } from './apiService';

export const onboardingService = {
  // 一次提交 wizard 的三要件。後端建立 warehouse / inventory_type / merchant
  // 並重置試用期起算日。失敗整批 rollback。
  //
  // payload shape:
  //   {
  //     warehouse:      { name, storage_mode },
  //     inventory_type: { code, name },        // 可省略
  //     merchant:       { name }               // standard plan 可省略（註冊時已自動建立）
  //   }
  complete: async (payload) => {
    const response = await operatorApiFetch('onboarding/complete', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return response.json();
  },
};
